import { Box, Text } from '@bechtel/gds';
import { useLingui } from '@lingui/react';
export const ErrorField = ({ error }) => {
  const { i18n } = useLingui();
  return (
    <Box pt={{ sm: '200' }}>
      <Text color="bechtel.red">{i18n._(error)}</Text>
    </Box>
  );
};
